import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconGroup(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M10 21C9.45 21 8.97917 20.8042 8.5875 20.4125C8.19583 20.0208 8 19.55 8 19V16H5C4.45 16 3.97917 15.8042 3.5875 15.4125C3.19583 15.0208 3 14.55 3 14V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H14C14.55 3 15.0208 3.19583 15.4125 3.5875C15.8042 3.97917 16 4.45 16 5V8H19C19.55 8 20.0208 8.19583 20.4125 8.5875C20.8042 8.97917 21 9.45 21 10V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H10ZM10 19H19V10H16C15.45 10 14.9792 9.80417 14.5875 9.4125C14.1958 9.02083 14 8.55 14 8V5H5V14H8C8.55 14 9.02083 14.1958 9.4125 14.5875C9.80417 14.9792 10 15.45 10 16V19Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
